import { Box, Header, Text } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const ButtonsContainer = Box.withConfig({
  marginTop: '$6',
  maxWidth: '300px',
});

export const HeaderStyled = Header.withConfig({
  focusable: true,
  accessible: true,
  accessibilityRole: 'header',
  color: getDesignToken('text-hero-light'),
  variant: 'hero',
  lineHeight: 'xs',
  fontWeight: 700,
  marginBottom: '$0',
  fontSize: {
    base: '4xl',
    md: '5xl',
    lg: '6xl',
  },
});

export const DisclaimerText = Text.withConfig({
  fontSize: '9px',
  marginBottom: '$2',
  alignSelf: 'flex-start',
});
